import { render, staticRenderFns } from "./courseScore.vue?vue&type=template&id=dee85a42&scoped=true&"
import script from "./courseScore.vue?vue&type=script&lang=js&"
export * from "./courseScore.vue?vue&type=script&lang=js&"
import style0 from "./courseScore.vue?vue&type=style&index=0&id=dee85a42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee85a42",
  null
  
)

export default component.exports